import { API, graphqlOperation } from "aws-amplify";
import { updateEndorsement as updateEndorsementMutation } from "../graphql/mutations";

export default async function updateEndorsement(id) {
    let res = await API.graphql(graphqlOperation(updateEndorsementMutation, { input: { id: id, report: false } }));
    return res;
}